import {Component, Inject, LOCALE_ID} from '@angular/core';
import {RouteTranslations} from '../../../models/abstract/routeTranslations';
import {LanguageService} from '../../../shared/services/language.service';

@Component({
    selector: 'course-trial-support-article',
    template: `
        <ng-container i18n="@@support.articles.trial">
            <p>Anyone can try the course for free. In the trial version you can try out the first lessons of the course.</p>
            <p>Had fun with the trial? <a routerLink="/{{ RouteTranslations.purchase[languageService.getActiveLanguageCode()] }}">Buy the course in the webshop!</a></p>
            <h2>Keep your progress from the trial</h2>
            <p>When you log in for the first time after purchase, you will be asked if you want to keep your results from the trial version. This way you can immediately continue where you left off in the trial version!</p>
            <p>Of course you also have the option to start over with a clean slate. In that case, your results from the trial version will be erased.</p>
        </ng-container>
    `
})
export class TrialSupportArticleComponent {
    protected readonly RouteTranslations = RouteTranslations;
    constructor(
        public languageService: LanguageService
    ) {}
}
